import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function friendlyError(err) {
  const d = err?.response?.data;
  if (!d) return err?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (d.detail) return typeof d.detail === "string" ? d.detail : JSON.stringify(d.detail);
  return "Request failed. Please try again.";
}
